import { styled } from '@mui/material/styles';

export const Placeholder = styled('div')`
  display: flex;
  justify-content: center;
`;
